import { Injectable } from '@angular/core';
import { Store } from '@core/services/store.service';
import { Observable, of } from 'rxjs';

@Injectable()
export class PermissionStore extends Store<any> {
  constructor() {
    super({
      pageAccess: {},
      assetAccess: [],
    });
  }

  setStore(data: any, type: string = 'P'): void {
    const permissionMap: Record<string, boolean> = {};

    if (type === 'P') {
      const flatData = [...this.flat(data)];
      flatData.forEach((permission: any) => {
        permissionMap[permission.name] = permission.allowed;
      });
      this.setState({ ...this.state, ...permissionMap });
    } else if (type === 'pageAccess' || type === 'assetAccess') {
      // Handle setting pageAccess or assetAccess
      this.setState({ ...this.state, [type]: data });
    } else {
      data.forEach((permission: any) => {
        permissionMap['GALKP_' + permission.key] = permission.lookuprolepermissions;
      });
      this.setState({ ...this.state, ...permissionMap });
    }
  }

  getStore(type: string = 'P'): Observable<any> {
    if (type === 'P') return of(this.state.permissions);
    else if (type === 'pageAccess') return of(this.state.pageAccess);
    else if (type === 'assetAccess') return of(this.state.assetAccess);
    else return of(this.state.lookupPermissions);
  }

  private flat(array: any[]) {
    let result: any[] = [];
    array.forEach(item => {
      result.push(item);
      if (item.permissions && Array.isArray(item.permissions)) {
        result = result.concat(this.flat(item.permissions));
      }
    });
    return result;
  }
}
